export const getCostXCredentialsAndCreateToken = async (connectorId, mcId, masterConnectors) => {
  try {
    console.log('Fetching CostX credentials for connector:', connectorId);
    
    // Find the CostX master connector details
    const costXConnector = masterConnectors.find(mc => 
      (mc.mcRecId?.toString() === mcId?.toString() || 
       mc.mcId?.toString() === mcId?.toString()) && 
      mc.mcName === "CostX"
    );
    
    if (!costXConnector) {
      throw new Error('CostX master connector not found');
    }
    
    // Check if mcUserName and mcPassword are available
    if (!costXConnector.mcUserName || !costXConnector.mcPassword) {
      throw new Error('CostX credentials not found in master connector data');
    }
    
    // Convert username and password to base64 separately
    const username = costXConnector.mcUserName;
    const password = costXConnector.mcPassword;
    
    // Combine in the format username:password
    const tokenValue = "Basic" + " " + btoa(`${username}:${password}`);
    
    console.log('Generated CostX token:', tokenValue);
    
    return tokenValue;
  } catch (error) {
    console.error('Error getting CostX credentials:', error);
    throw error;
  }
};